import { Typography, TypographyProps } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

interface AnimatedTypographyProps extends TypographyProps {
    animationDelay?: string; // npr. '0.3s'
    threshold?: number;      // npr. 0.3
}

const AnimatedTypography: React.FC<AnimatedTypographyProps> = ({
    animationDelay = '0s',
    threshold = 0.3,
    sx,
    ...props
}) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect(); // samo jednom
                }
            },
            { threshold }
        );

        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, [threshold]);

    return (
        <Typography
            ref={ref}
            {...props}
            sx={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'none' : 'scale(0.95) rotate(-2deg)',
                transition: visible
                    ? `opacity 0.5s ease-out ${animationDelay}, transform 0.5s ease-out ${animationDelay}`
                    : 'none',
                visibility: visible ? 'visible' : 'hidden',
                ...sx,
            }}
        />
    );
};

export default AnimatedTypography;
